<template>
  <el-scrollbar class="right-tree"
    style="height: 392px;margin: 10px 60px 10px 10px;border: 1px solid rgba(88, 101, 131, 0.3);width: 450px">
    <el-tree :props="controlCenterProps" ref="searchTree" :data="searchData" node-key="resCode" :default-expand-all="true"
      style="margin-bottom: 12px;" :render-content="renderContent" />
  </el-scrollbar>
</template>

<script>
export default {
  name: 'link-right-tree',
  props: {
    deviceType: {
      type: String,
      default: () => ''
    },
    deviceName: {
      type: String,
      default: () => ''
    },
    positions: {
      type: Array,
      default: () => []
    },
    radius: {
      type: String,
      default: () => ''
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    deviceName: function (newVal) {
      this.handleSearchTree()
    },
    positions: function (newVal) {
      this.handleSearchTree()
    },
    radius: function (newVal) {
      this.handleSearchTree()
    },
    deviceType: function (newVal) {
      this.handleSearchTree()
    },
    tableData: function (newVal) {
      if (newVal.length === 0 || !newVal) {
        this.searchData = []
      }
    }
  },
  data() {
    return {
      searchData: [],
      selectedData: [],
      isSearch: false,
      checkList: [],
      musicId: '',
      radioOptions: [],
      currentId: '',
      controlCenterProps: {
        children: 'childs',
        label: 'resName',
        isLeaf: 'isDevice',
        disabled: 'readOnly'
      },
      renderContent: (h, { node, data, store }) => {
        console.log(
          '🚀 ~ file: link-right-tree.vue ~ line 74 ~ data ~ data',
          data
        )
        let iconClass = ''
        if (!node.data.isDevice) {
          if (node.level === 2) {
            iconClass = 'soc iconLevelOne'
          } else if (node.level === 3) {
            iconClass = 'soc iconLevelTwo'
          } else {
            iconClass = 'soc iconLevelThree'
          }
          return h(
            'div',
            {
              attrs: { class: 'clickClass' }
            },
            [
              h('i', {
                attrs: { class: iconClass }
              }),
              h('span', { style: { marginLeft: '10px' } }, node.label),
              h(
                'span',
                { style: { color: '#8696B5' } },
                this.handleLabelStyle(data.totalNum, data.onNum)
              )
            ]
          )
        } else {
          iconClass = this.switchCameraIcon(node.data.resType)
          let status = data.status === 2 ? ' off-line' : ''
          iconClass = iconClass + status
          return (
            <div
              class="clickClass"
              on-click={value => this.handleNodeCheck(value, data)}
            >
              <i class={iconClass} style={{ marginRight: '10px' }} />
              <span style={{ marginRight: '60px' }}>{node.label}</span>
              {data.resCode === this.currentId ? (
                <div class="checkClass">
                  {
                    data.resType === '3001' ? <el-select placeholder="请选择"
                      v-model={this.musicId}
                      popper-class={'cameraPopSelect'}
                      style={{ width: '150px' }}>
                      {
                        this.radioOptions.map(item => <el-option key={item.id} label={item.name} value={item.id} />)
                      }
                    </el-select> : ''
                  }
                  {
                    data.resType === '18' ? <el-checkbox-group v-model={this.checkList}>
                      <el-checkbox label={1}>
                        <i class="soc iconBatchCapture" />
                      </el-checkbox>
                      <el-checkbox label={3}>
                        <i class="soc iconVideo1" />
                      </el-checkbox>
                    </el-checkbox-group> : ''
                  }
                  {
                    data.resType === '25' || data.resType === '22' ? <el-checkbox-group v-model={this.checkList}>
                      <el-checkbox label={4}>
                        <i class="soc iconkaizhaxiao" />
                      </el-checkbox>
                    </el-checkbox-group> : ''
                  }
                  <i class="soc iconDetermine" style={{ padding: '0 5px', marginLeft: '10px' }}
                    on-click={value => this.updateTree(value, data)} />
                  <i class="soc iconCancelIcon" style={{ padding: '0 5px' }} on-click={value => this.cancelTree(value)} />
                </div>
              ) : (
                ''
              )}
            </div>
          )
        }
      }
    }
  },
  mounted() {
    this.handleSearchTree();
    // this.queryMusicList();
  },
  methods: {
    queryMusicList() {
      let param = {
        name: '',
        pageBean: { pageSize: 100, pageNo: 1 }
      }
      queryMusicList(param).then(res => {
        if (!res.success) {
          return
        }
        if (!res.data) {
          return
        }
        this.radioOptions = res.data.list
      })
    },
    handleSelect(val) {

    },
    cancelTree(e) {
      e.cancelBubble = true
      this.currentId = ''
      this.checkList = []
    },
    updateTree(e, data) {
      e.cancelBubble = true
      console.log('*******', data, this.checkList)
      if (data.resType === '18' || data.resType === '22' || data.resType === '25') {
        this.$emit('handleUpdateTable', data, this.checkList)
      }
      if (data.resType === '3001') {
        this.$emit('handleUpdateTable', data, [6], this.musicId)
      }
      this.currentId = ''
      this.checkList = []
      this.musicId = ''
    },
    handleNodeCheck(e, data) {
      e.cancelBubble = true
      if (data.isDevice) {
        this.currentId = data.resCode
      }
    },
    handleLabelStyle(cameraCount, cameraOnLineCount) {
      return (
        '（' +
        cameraOnLineCount +
        '/' +
        cameraCount +
        '\t\t\t\t\t\t' +
        this.handleCameraRate(cameraOnLineCount, cameraCount) +
        '%）'
      )
    },
    handleCameraRate(num1, num2) {
      if (num2 === 0) {
        return 0
      }
      return Math.round((100 * num1) / num2)
    },
    /**
     * 获取图标
     * @param val
     * @return {string}
     */
    switchCameraIcon(val) {
      switch (val) {
        case '18':
          return 'soc iconGunMachine device'
        case '1102':
          return 'soc iconGunMachine device'
        case '1103':
          return 'soc iconBallMachine device'
        case '1104':
          return 'soc iconHalfMachine device'
        case '1105':
          return 'soc iconGunMachine device'
      }
    },
    handleSearchTree() {
      if (!this.tableData || this.tableData.length === 0) {
        return
      }
      let radius = ''
      if (this.radius === '40') {
        radius = ''
      } else {
        radius = this.radius
      }
      let param = {
        deviceName: this.deviceName,
        deviceType: this.deviceType,
        positions: this.positions,
        radius: radius
      }
      this.$fetch('/bas/linkage-rule/getActionDeviceByPosition.json', param).then(res => {
        if (!res.success) {
          return
        }
        if (!res.returnObj) {
          this.searchData = []
          return
        }
        this.searchData = Object.freeze(res.returnObj)
      })
    }
  }
}
</script>

<style lang="scss">
.right-tree {
  &.transferDialog {
    height: auto;
  }

  -ms-overflow-style: scrollbar !important;
  scrollbar-arrow-color: #407aee !important;
  /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #407aee !important;
  /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #272f4a !important;
  /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #272f4a !important;
  /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #272f4a !important;
  /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #272f4a !important;
  /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #272f4a !important;
  /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #272f4a !important;
  /**/
  /*滚动条的基本颜色*/
  height: 100%;

  .el-tree-node .el-tree-node__content:before {
    margin-left: 20px !important;
    margin-top: -19px !important;
  }

  .el-tree-node {
    position: relative;
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    padding-left: 33px !important;
  }

  .el-tree>.el-tree-node>.el-tree-node__content:first-child {

    &::before,
    &::after {
      border: none;
    }
  }

  .el-checkbox__inner {
    border-radius: 0;
    border: 1px solid #586583;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #407aee !important;
    border-color: #407aee;
  }

  .el-tree-node__content .is-leaf:before {
    content: '';
    border: 0 solid #8696b5;
    width: 3px;
    margin-right: 0;
  }

  .el-tree-node__children .el-icon-caret-right:after {
    content: '';
    position: absolute;
    display: inline-block;
    height: 1px;
    width: 8px;
    left: -11px;
    top: 5px;
    background-color: #62687d;
  }

  .el-tree-node__children .el-icon-caret-right:after {
    left: 20px !important;
  }

  .el-tree-node .el-tree-node__content:before {
    margin-left: 20px !important;
    margin-top: -19px !important;
  }

  .el-tree-node .el-tree-node__content:before {
    content: '';
    position: absolute;
    right: auto;
    border-left: 1px solid #62687d;
    bottom: 50px;
    height: 100%;
    top: 0;
    width: 1px;
    margin-left: -11px;
    margin-top: -18px;
    z-index: 1;
  }

  .el-tree .is-current>.el-tree-node__content {
    background: linear-gradient(to right,
        rgb(56, 102, 491),
        rgb(46, 76, 140),
        rgb(38, 62, 105),
        transparent);
    background: -ms-linear-gradient(left, #294078, var(--park-component-bg-color));
    background: -webkit-linear-gradient(left, #294078, var(--park-component-bg-color));
    background: -moz-linear-gradient(left, #294078, var(--park-component-bg-color));
  }

  .el-tree .el-tree-node>.el-tree-node__content:hover {
    background: rgba(70, 82, 117, 0.4);
  }

  .el-tree>.el-tree-node {
    min-width: 100%;
    display: inline-block;
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    transform: rotate(0deg) !important;
    padding: 0;
    font-family: 'soc' !important;
    font-size: 12px;
    font-style: normal;
  }

  .el-icon-caret-right:before {
    content: '\e69c';
    display: inline-block;
    border: 1px solid hsla(0, 0%, 100%, 0.3);
    width: 13px;
    height: 13px;
    margin-right: 6px;
    line-height: 13px;
    text-align: center;
    color: hsla(0, 0%, 100%, 0.3);
    margin-top: -2px;
  }

  .expanded.el-icon-caret-right:before {
    content: '\e69d';
    display: inline-block;
    border: 1px solid hsla(0, 0%, 100%, 0.3);
    width: 13px;
    height: 13px;
    margin-right: 6px;
    line-height: 13px;
    text-align: center;
    color: #407aee;
  }

  .el-tree .el-tree-node {
    .el-tree-node__content {
      height: 36px !important;

      .clickClass {
        width: 100%;
        display: flex;
        align-items: center;
        height: 36px;
        padding-right: 36px;

        &.off_line {
          color: rgba(#fff, 0.4);

          .typeIcon {
            color: rgba(#fff, 0.4);
          }

          .ellipsis_text {
            color: rgba(#fff, 0.4) !important;
          }

          .attrType_icon {
            position: absolute;
            right: 3px;
            top: 0;
            font-size: 24px;
            line-height: 36px;
          }
        }

        .typeIcon {
          margin-right: 5px;
          color: #fff;
          font-size: 20px;
        }

        .ellipsis_text {
          margin-right: 25px;
          color: #fff;
        }

        .attrType_icon {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 24px;
          line-height: 36px;
        }

        .online_text {
          color: #8696b5;
        }
      }
    }
  }
}

.clickClass {
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  padding-right: 36px;

  .iconBallMachine {
    font-size: 12px;
  }

  .device {
    font-size: 14px;
  }

  .checkClass {
    display: flex;
    align-items: center;
    color: #8696b5;
  }

  .el-checkbox {
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    color: #8696b5;

    .iconBatchCapture {
      font-size: 22px;
    }

    .iconVideo1 {
      font-size: 21px;
    }

    .soc {
      line-height: 36px;
    }
  }
}

.off-line {
  color: rgba(#fff, 0.4);
}

.el-table__row {
  &:first-child {
    .iconjiantou-copy-copy1 {
      cursor: not-allowed;
      opacity: 0.2;
    }
  }

  &:last-child {
    .iconjiantou1 {
      cursor: not-allowed;
      opacity: 0.2;
    }
  }
}</style>
